module.exports = __webpack_public_path__ + "img/product-icon-2.3fde888b.svg";